export default "__VITE_PUBLIC_ASSET__d60a8b54__"